import { render, staticRenderFns } from "./AttributeReferenceGroup.vue?vue&type=template&id=14a77424&scoped=true&"
import script from "./AttributeReferenceGroup.vue?vue&type=script&lang=ts&"
export * from "./AttributeReferenceGroup.vue?vue&type=script&lang=ts&"
import style0 from "./AttributeReferenceGroup.vue?vue&type=style&index=0&id=14a77424&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a77424",
  null
  
)

export default component.exports